import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=06689735&scoped=true&lang=pug&"
import script from "./IconShare.vue?vue&type=script&lang=js&"
export * from "./IconShare.vue?vue&type=script&lang=js&"
import style0 from "./IconShare.vue?vue&type=style&index=0&id=06689735&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06689735",
  null
  
)

export default component.exports